// extracted by mini-css-extract-plugin
module.exports = {"tools":"IpdTypesPage_tools__3GuWF","mobileTools":"IpdTypesPage_mobileTools__h7P6k","page":"IpdTypesPage_page__2iiob","right":"IpdTypesPage_right__2xLS1"};